import "./CaseStudy5StarResortIndiaRevenueOptimization.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Initialchallenges from "./sections/Initialchallenges";
import RevenueStrategy from "./sections/RevenueStrategy";
import Performance from "./sections/Performance";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudy5StarResortIndiaRevenueOptimizationPage() {
  return <div>
      <Header />
      <Hero />
      <Initialchallenges />
      <RevenueStrategy />
      <Performance />
      <Faq />
      <Footer />
    </div>;
}